
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/things-to-do/events/[slug]",
      function () {
        return require("private-next-pages/things-to-do/events/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/things-to-do/events/[slug]"])
      });
    }
  